import ContributionList from '@/contributions/ContributionList'
import ContributionShow from '@/contributions/ContributionShow'
import DynamicFormOutlinedIcon from '@mui/icons-material/DynamicFormOutlined'

export default {
    icon: DynamicFormOutlinedIcon,
    list: ContributionList,
    show: ContributionShow
}
